import styled from 'styled-components/macro';

export const SensorDataText = styled.span`
    font-weight: bold;
`;
